import {createApp} from 'vue'
import FormInputRichText from './FormInputRichText'

const el = '.kb-component--form-input-rich-text'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FormInputRichTextDOM)=>{

            const props = {
                errorMessageLabel: FormInputRichTextDOM.dataset.errormessagelabel,
                placeholder: FormInputRichTextDOM.dataset.placeholder,
                label: FormInputRichTextDOM.dataset.label,
                isRequired: FormInputRichTextDOM.dataset.isrequired === 'true',
                fieldName: FormInputRichTextDOM.dataset.fieldname,
                isValidationError: FormInputRichTextDOM.dataset.isValidationError
            }

            const component = createApp(FormInputRichText, props).use(Store)
            component.mount(FormInputRichTextDOM)
        })
    }
}